<template>
  <c-select
    class="CoinSelect"
    :errorHave="false"
    :value="myValue"
    :options="options"
    :filterable="true"
    newStyleFormat
    fill
    @onChanges="selectLineChange">
    </c-select>
</template>

<script>
export default {
  name: 'AccountSelect',
  props: {
    value: {
      type: String,
      default: '',
    },
    // 是否初始化第一个symbol
    init: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      myValue: '',
      options: [
        {
          value: this.$t('assets.otcAccount.otcAccount'),
          code: 'otc',
        },
        {
          value: this.$t('futures.transfer.coAccount'),
          code: 'future',
        },
      ],
      otcAccountList: [],
    };
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.setMyValue();
      },
    },
  },
  methods: {
    setMyValue() {
      try {
        this.myValue = this.value;
      } catch (error) {
        this.myValue = '';
      }
    },

    selectLineChange(item) {
      this.myValue = item.code;
      this.onUpdate();
    },

    onUpdate() {
      this.$emit('input', this.myValue);
      this.$emit('change', this.myValue);
    },
  },
};
</script>
